<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import { numeric, required } from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import { pagingModel } from "@/models/core/pagingModel";
import VueMultiselect from "vue-multiselect";
import { doanhNghiepModel } from "@/models/profession/bussiness/doanhNghiepModel";
import DatePicker from "vue2-datepicker";
import Treeselect from "@riophae/vue-treeselect";

import CustomTable from "@/components/custom-table.vue";
import SearchCard from "@/components/search-card.vue";

export default {
  page: {
    title: "Danh sách doanh nghiệp",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, CustomTable, SearchCard, VueMultiselect },
  data() {
    return {
      title: "Danh sách doanh nghiệp",
      items: [
        {
          text: "Bài viết",
          href: "/danh-sach-doanh-nghiep",
        },
        {
          text: "Danh sách",
          active: true,
        },
      ],
      data: [],
      fields: [
        {
          key: "STT",
          label: "STT",
          class: "td-stt text-center font-bold text-primary-custom w-[70px]",
          sortable: false,
          thClass: "th-custom-style text-center",
        },
        {
          key: "name",
          label: "Tên doanh nghiệp",
          class: "td-username font-body text-sm font-semibold text-on-surface-custom",
          sortable: false,
          thClass: "th-custom-style",
        },
        {
          key: "diaChi",
          label: "Địa chỉ",
          class: "td-username font-body text-sm text-on-surface-custom",
          sortable: false,
          thClass: "th-custom-style",
        },
        {
          key: "sdt",
          label: "Số điện thoại",
          class: "td-username font-body text-sm text-on-surface-custom",
          sortable: false,
          thClass: "th-custom-style",
        },
        {
          key: "process",
          label: "Xử lý",
          class: "text-center w-[120px]",
          sortable: false,
          thClass: "th-custom-style text-center",
        },
      ],
      searchFields: [
        {
          key: "content",
          label: "Tìm kiếm doanh nghiệp",
          placeholder: "Tìm kiếm theo tiêu đề hoặc tên doanh nghiệp...",
          col: 12,
          type: "text",
        }
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      showModal: false,
      showDeleteModal: false,
      submitted: false,
      sortBy: "age",
      filter: null,
      sortDesc: false,
      filterOn: [],
      numberOfElement: 1,
      totalRows: 1,
      model: doanhNghiepModel.baseJson(),
      listFruit: [],
      selectedFruits: [],
      listCoQuan: [],
      listRole: [],
      pagination: pagingModel.baseJson(),
      itemFilter: {
        content: null,
        ngayBatDau: null,
        ngayKetThuc: null,
        menuId: null,
      },
      treeView: [],
    };
  },
  computed: {
    rules() {
      return {
        name: { required },
        nameEn: { required },
        // link: { required },
      };
    },
  },
  validations: {
    model: {
      name: { required },
      nameEn: { required }
      // link: { required },
    },
  },
  methods: {

    async fnGetList() {
      this.$refs.tblList?.refresh();
    },

    async getListFruit() {
      await this.$store.dispatch("profession/traiCay/traiCayStore/getAll").then((res) => {
        this.listFruit = (res.data || []).map((item) => ({
          code: item.code,
          name: item.name,
        }));
      });
    },
    async handleDelete() {
      if (this.model._id) {
        await this.$store
          .dispatch("profession/doanhNghiep/doanhNghiepStore/delete", { _id: this.model._id })
          .then((res) => {
            if (res.code === 0) {
              this.fnGetList();
              this.showDeleteModal = false;
            }
            this.$store.dispatch("snackBarStore/addNotify", {
              message: res.message,
              code: res.code,
            });
          });
      }
    },
    handleShowDeleteModal(id) {
      this.model._id = id;
      this.showDeleteModal = true;
    },
    async handleSubmit() {
      console.log("LOG THONG TIN ", this.model);
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.model.traiCay = (this.selectedFruits || []).map(f => f.code);
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      const action = this.model._id ? "profession/doanhNghiep/doanhNghiepStore/update" : "profession/doanhNghiep/doanhNghiepStore/create";
      await this.$store
        .dispatch(action, doanhNghiepModel.toJson(this.model))
        .then((res) => {
          if (res.code === 0) {
            this.showModal = false;
            this.model = doanhNghiepModel.baseJson();
            this.$refs.tblList.refresh();
          }
          this.$store.dispatch("snackBarStore/addNotify", {
            message: res.message,
            code: res.code,
          });
        });
      loader.hide();
      this.submitted = false;
    },
    async handleUpdate(id) {
      await this.$store
        .dispatch("profession/doanhNghiep/doanhNghiepStore/getById", { _id: id })
        .then((res) => {
          if (res.code === 0) {
            console.log(res);
            this.model = doanhNghiepModel.fromJson(res.data);
            this.selectedFruits = (this.model.traiCay || []).map(code => {
              const fruit = this.listFruit.find(f => f.code === code);
              return fruit ? fruit : { code, name: code };
            });
            this.showModal = true;
          } else {
            this.$store.dispatch("snackBarStore/addNotify", {
              message: res.message,
              code: res.code,
            });
          }
        });
    },
    addCoQuanToModel(node, instanceId) {
      if (node.id) {
        this.itemFilter.menuId = node.id;
      }
    },
    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        content: this.itemFilter.content,
        sortDesc: true,
        maVung: this.itemFilter.maVung,
        soDienThoai: this.itemFilter.soDienThoai,
        maSoThue: this.itemFilter.maSoThue,
      };
      this.loading = true;
      try {
        let promise = this.$store.dispatch(
          "profession/doanhNghiep/doanhNghiepStore/getPagingParams",
          params
        );
        return promise.then((resp) => {
          let items = (resp.data && resp.data.data) ? resp.data.data.map(item => doanhNghiepModel.fromJson(item)) : [];
          this.totalRows = resp.data ? resp.data.totalRows : 0;
          this.numberOfElement = items.length;
          this.loading = false;
          return items || [];
        });
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.$refs.tblList.refresh();
    },
    handleClear() {
      this.itemFilter = {
        content: null,
        ngayBatDau: null,
        ngayKetThuc: null,
        menuId: null,
      };
      this.$refs.tblList.refresh();
    },
  },
  mounted() {
    this.getListFruit();
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
      },
    },
    showModal(status) {
      if (status == false) {
        this.model = doanhNghiepModel.baseJson();
        this.selectedFruits = [];
        this.submitted = false;
        this.$v.$reset();
      }
    },
    showDeleteModal(val) {
      if (val == false) {
        this.model._id = null;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="enterprise-list-container">

      <!-- Header của trang danh sách -->
      <header class="header-wrapper">
        <div>
          <PageHeader :title="title" :items="items" class="p-0 m-0 border-0" />
        </div>
        <!-- Nút thêm mới doanh nghiệp -->
        <button @click="showModal = true" class="btn-add">
          Thêm doanh nghiệp mới
        </button>
      </header>

      <div class="row">
        <div class="col-12">
          <div class="card-premium">

            <!-- Bộ lọc tìm kiếm -->
            <SearchCard :value="itemFilter" :fields="searchFields" @search="handleSearch" @clear="handleClear" />


            <!-- Điều khiển hiển thị số dòng của Bảng -->
            <div class="table-controls-bar">
              <div class="pagination-control-row">
                <span>Hiển thị</span>
                <select v-model="perPage" class="per-page-select">
                  <option v-for="opt in pageOptions" :key="opt" :value="opt">{{ opt }}</option>
                </select>
                <span>dòng trên mỗi trang</span>
              </div>
            </div>

            <!-- Bảng quản trị (Sử dụng component CustomTable tái sử dụng) -->
            <CustomTable :items="myProvider" :fields="fields" striped bordered responsive="sm" :per-page="perPage"
              v-model="currentPage" :number-of-element="numberOfElement" :total-rows="totalRows" :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc" :filter="filter" :filter-included-fields="filterOn" ref="tblList"
              primary-key="_id">
              <template v-slot:cell(STT)="data">
                {{ data.index + (currentPage - 1) * perPage + 1 }}
              </template>

              <template v-slot:cell(process)="data">
                <div class="action-buttons-flex">
                  <!-- Nút Sửa -->
                  <button type="button" class="btn-edit" @click="handleUpdate(data.item._id)"
                    title="Chỉnh sửa thông tin"></button>

                  <!-- Nút Xoá -->
                  <button type="button" class="btn-del" @click="handleShowDeleteModal(data.item._id)"
                    title="Xóa doanh nghiệp"></button>
                </div>
              </template>
            </CustomTable>

          </div>
        </div>
      </div>
    </div>

    <!-- MODAL THÊM/SỬA DOANH NGHIỆP BENTO GRID -->
    <b-modal v-model="showModal" title="Thông tin doanh nghiệp liên kết"
      title-class="modal-delete-title text-success-custom" body-class="p-4" hide-footer centered no-close-on-backdrop
      size="lg">
      <form @submit.prevent="handleSubmit" ref="formContainer">
        <div class="row">
          <!-- Tên doanh nghiệp (VI) -->
          <div class="col-md-6 form-group-custom">
            <label class="form-label-custom">Tên doanh nghiệp <span class="text-danger">*</span></label>
            <input type="hidden" v-model="model._id" />
            <input v-model="model.name" type="text" class="form-control-custom"
              :class="{ 'border-danger-custom': submitted && $v.model.name.$error }"
              placeholder="Nhập tên doanh nghiệp (Tiếng Việt)" />
            <div v-if="submitted && !$v.model.name.required" class="error-text-custom">
              Tên doanh nghiệp không được để trống
            </div>
          </div>

          <!-- Tên doanh nghiệp (EN) -->
          <div class="col-md-6 form-group-custom">
            <label class="form-label-custom">Tên doanh nghiệp (English) <span class="text-danger">*</span></label>
            <input v-model="model.nameEn" type="text" class="form-control-custom"
              :class="{ 'border-danger-custom': submitted && $v.model.nameEn.$error }"
              placeholder="Enter enterprise name (English)" />
            <div v-if="submitted && !$v.model.nameEn.required" class="error-text-custom">
              Tên doanh nghiệp (English) không được để trống
            </div>
          </div>

          <!-- Địa chỉ (VI) -->
          <div class="col-md-6 form-group-custom">
            <label class="form-label-custom">Địa chỉ chính</label>
            <textarea v-model="model.diaChi" class="form-control-custom" rows="3"
              placeholder="Nhập địa chỉ trụ sở chính (Tiếng Việt)..."></textarea>
          </div>

          <!-- Địa chỉ (EN) -->
          <div class="col-md-6 form-group-custom">
            <label class="form-label-custom">Địa chỉ chính (English)</label>
            <textarea v-model="model.diaChiEn" class="form-control-custom" rows="3"
              placeholder="Enter main office address (English)..."></textarea>
          </div>

          <!-- Số điện thoại -->
          <div class="col-md-6 form-group-custom">
            <label class="form-label-custom">Số điện thoại</label>
            <input v-model="model.sdt" type="text" class="form-control-custom" placeholder="Ví dụ: 028 1234 5678" />
          </div>

          <!-- Liên kết Website -->
          <div class="col-md-6 form-group-custom">
            <label class="form-label-custom">Liên kết</label>
            <input v-model="model.link" type="url" class="form-control-custom" placeholder="https://example.com" />

          </div>

          <!-- Giới thiệu doanh nghiệp (VI) -->
          <div class="col-md-6 form-group-custom">
            <label class="form-label-custom">Giới thiệu doanh nghiệp</label>
            <textarea v-model="model.content" class="form-control-custom" rows="4"
              placeholder="Nhập thông tin giới thiệu, lĩnh vực kinh doanh (Tiếng Việt)..."></textarea>
          </div>

          <!-- Giới thiệu doanh nghiệp (EN) -->
          <div class="col-md-6 form-group-custom">
            <label class="form-label-custom">Giới thiệu doanh nghiệp (English)</label>
            <textarea v-model="model.contentEn" class="form-control-custom" rows="4"
              placeholder="Enter enterprise description, business sectors (English)..."></textarea>
          </div>

          <!-- Sản phẩm trái cây liên kết -->
          <div class="col-12 form-group-custom">
            <label class="form-label-custom">Sản phẩm trái cây liên kết</label>
            <VueMultiselect v-model="selectedFruits" :options="listFruit" :multiple="true" label="name" track-by="code"
              placeholder="Chọn các loại trái cây đặc sản..." selectLabel="Nhấn để chọn" deselectLabel="Nhấn để bỏ chọn"
              selectedLabel="Đã chọn" appendToBody>
            </VueMultiselect>
          </div>
        </div>

        <div class="text-end pt-3 mt-4 border-top d-flex justify-content-end gap-2">
          <button type="button" class="btn-close-form" @click="showModal = false">
            Đóng
          </button>
          <button type="submit" class="btn-save">
            Lưu thay đổi
          </button>
        </div>
      </form>
    </b-modal>

    <!-- MODAL XÓA DOANH NGHIỆP -->
    <b-modal v-model="showDeleteModal" centered title="Xóa thông tin doanh nghiệp" title-class="modal-delete-title"
      no-close-on-backdrop>
      <div class="modal-delete-body">
        <span class="isax isax-danger warning-icon"></span>
        <div>
          <p class="warning-main-text">Hành động này không thể hoàn tác!</p>
          <p class="warning-sub-text">
            Thông tin doanh nghiệp liên kết này sẽ hoàn toàn bị xóa khỏi hệ thống quảng bá của sự kiện. Bạn có chắc chắn
            muốn tiếp tục?
          </p>
        </div>
      </div>

      <template #modal-footer>
        <button type="button" class="btn-close-form" @click="showDeleteModal = false">
          ĐÓNG
        </button>
        <button type="button" class="btn-del" @click="handleDelete">
          ĐỒNG Ý XÓA
        </button>
      </template>
    </b-modal>

  </Layout>
</template>

<style scoped>
/* ======================== THỜI GIAN & CHỦ ĐỀ CHUNG ======================== */
.header-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
  gap: 16px;
}

@media (min-width: 768px) {
  .header-wrapper {
    flex-direction: row;
    align-items: flex-end;
  }
}

/* Nút thêm mới */
.add-btn-style {
  padding: 12px 24px;
  border-radius: 8px;
  background-color: var(--color-public-primary, #2e7d32);
  color: #ffffff;
  border: none;
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(46, 125, 50, 0.15);
  transition: all 0.2s ease-in-out;
}

.add-btn-style:hover {
  background-color: #1b5e20;
  box-shadow: 0 4px 12px rgba(46, 125, 50, 0.25);
  transform: translateY(-1px);
}

.icon-btn-add {
  font-size: 18px;
}

/* ======================== THỆ CARD CAO CẤP ======================== */
.card-premium {
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid rgba(187, 202, 186, 0.3);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  margin-bottom: 24px;
}

/* Bộ lọc tìm kiếm */
.search-filters-box {
  padding: 24px;
  border-bottom: 1px solid rgba(187, 202, 186, 0.2);
  background: linear-gradient(135deg, rgba(46, 125, 50, 0.02) 0%, rgba(251, 140, 0, 0.02) 100%);
}

.filter-label {
  display: block;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-public-text-body, #374151);
  margin-bottom: 8px;
}

.search-input-wrapper {
  position: relative;
}

.search-input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(55, 65, 81, 0.5);
  font-size: 18px;
}

.search-input-control {
  width: 100%;
  padding: 12px 16px 12px 44px;
  border: 1px solid var(--outline-variant, #bfcaba);
  border-radius: 8px;
  background-color: #ffffff;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 14px;
  color: var(--color-public-text-body, #374151);
  outline: none;
  transition: border-color 0.2s;
}

.search-input-control:focus {
  border-color: var(--color-public-primary, #2e7d32);
}

/* Nút tìm kiếm & làm mới */
.btn-search-action {
  flex: 1;
  padding: 12px;
  background-color: var(--color-public-primary, #2e7d32);
  color: #ffffff;
  border: none;
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 12px;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-search-action:hover {
  background-color: #1b5e20;
  box-shadow: 0 4px 10px rgba(46, 125, 50, 0.15);
}

.btn-reset-action {
  padding: 12px 20px;
  background-color: #ffffff;
  color: var(--color-public-text-body, #374151);
  border: 1px solid var(--outline-variant, #bfcaba);
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 12px;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: background-color 0.15s;
}

.btn-reset-action:hover {
  background-color: var(--surface-container-low, #f1f5eb);
}

/* Điều khiển dòng hiển thị */
.table-controls-bar {
  padding: 16px 24px;
  border-bottom: 1px solid rgba(187, 202, 186, 0.1);
  background-color: rgba(241, 245, 235, 0.3);
}

.pagination-control-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 13px;
  color: var(--color-public-text-body, #374151);
}

.per-page-select {
  border: 1px solid rgba(187, 202, 186, 0.5);
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  outline: none;
  background-color: #ffffff;
  font-weight: 600;
  color: var(--color-public-text-body, #374151);
}

.primary-custom {
  color: var(--color-public-primary, #2e7d32);
}

.on-surface-custom {
  color: var(--color-public-text-body, #374151);
}

/* Hộp nút thao tác xử lý trong dòng bảng */
.action-buttons-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.action-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(187, 202, 186, 0.3);
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-success-custom {
  color: var(--color-status-success, #4caf50);
}

.btn-success-custom:hover {
  background-color: rgba(76, 175, 80, 0.08);
  border-color: var(--color-status-success, #4caf50);
}

.btn-danger-custom {
  color: var(--color-status-error, #d32f2f);
}

.btn-danger-custom:hover {
  background-color: rgba(211, 47, 47, 0.08);
  border-color: var(--color-status-error, #d32f2f);
}

/* Thanh chân bảng tin */
.table-footer-bar {
  padding: 24px;
  border-top: 1px solid rgba(187, 202, 186, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  background-color: rgba(241, 245, 235, 0.1);
}

@media (min-width: 576px) {
  .table-footer-bar {
    flex-direction: row;
  }
}

.footer-stats-text {
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 13px;
  color: var(--color-public-text-body, #374151);
}

.stats-highlight {
  font-weight: 700;
  color: var(--color-public-primary, #2e7d32);
}

/* ======================== MODAL XÓA DỮ LIỆU DÙNG CSS PHẦN TỬ ======================== */
::v-deep .modal-delete-title {
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-size: 18px;
  color: var(--color-status-error, #d32f2f);
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal-delete-body {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 4px;
}

.warning-icon {
  color: var(--color-status-error, #d32f2f);
  font-size: 32px;
  flex-shrink: 0;
}

.warning-main-text {
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: var(--color-public-text-body, #374151);
  margin-bottom: 4px;
}

.warning-sub-text {
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 12px;
  color: rgba(55, 65, 81, 0.8);
  margin: 0;
  line-height: 1.5;
}

.btn-cancel-delete {
  background-color: #ffffff;
  border: 1px solid var(--outline-variant, #bfcaba);
  padding: 8px 16px;
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-size: 11px;
  font-weight: 700;
  border-radius: 6px;
  cursor: pointer;
  color: var(--color-public-text-body, #374151);
  transition: background-color 0.15s;
}

.btn-cancel-delete:hover {
  background-color: var(--surface-container-low, #f1f5eb);
}

.btn-confirm-delete {
  background-color: var(--color-status-error, #d32f2f);
  border: none;
  padding: 8px 16px;
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-size: 11px;
  font-weight: 700;
  border-radius: 6px;
  cursor: pointer;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: background-color 0.15s;
}

.btn-confirm-delete:hover {
  background-color: #b71c1c;
}

/* ======================== BIỂU MẪU NHẬP LIỆU BENTO ======================== */
.form-group-custom {
  margin-bottom: 16px;
}

.form-label-custom {
  display: block;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-public-text-body, #374151);
  margin-bottom: 8px;
}

.form-control-custom {
  width: 100%;
  border: 1px solid var(--outline-variant, #bfcaba);
  border-radius: 8px;
  padding: 12px;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 14px;
  color: var(--color-public-text-body, #374151);
  background-color: #ffffff;
  outline: none;
  transition: all 0.2s ease-in-out;
}

.form-control-custom:focus {
  border-color: var(--color-public-primary, #2e7d32);
  box-shadow: 0 0 0 3px rgba(46, 125, 50, 0.12);
}

.border-danger-custom {
  border-color: var(--color-status-error, #d32f2f) !important;
}

.error-text-custom {
  color: var(--color-status-error, #d32f2f);
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 11px;
  margin-top: 4px;
  font-weight: 500;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  height: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(112, 122, 108, 0.2);
  border-radius: 4px;
}
</style>
